import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';
import {DeclarativeMutationConfig} from 'relay-runtime/lib/mutations/RelayDeclarativeMutationConfig';
import {Disposable, Environment} from 'relay-runtime';
import {
	DeleteProjectBillToInput,
	DeleteProjectBillToMutation,
	DeleteProjectBillToMutation$rawResponse,
} from './__generated__/DeleteProjectBillToMutation.graphql';
import {omit} from 'lodash';

const mutation = graphql`
	mutation DeleteProjectBillToMutation($input: DeleteProjectBillToInput!) @raw_response_type {
		deleteProjectBillTo(input: $input) {
			deletedProjectBillToId
		}
	}
`;

function getConfigs(input): DeclarativeMutationConfig[] {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: input.projectId,
			connectionKeys: [
				{
					key: 'Project_projectBillTos',
				},
			],
			pathToConnection: ['project', 'projectBillTos'],
			deletedIDFieldName: 'deletedProjectBillToId',
		},
	];
}

function getOptimisticResponse(input: DeleteProjectBillToInput): DeleteProjectBillToMutation$rawResponse {
	return {
		deleteProjectBillTo: {
			deletedProjectBillToId: input.projectBillToId,
		},
	};
}

function commit(
	environment: Environment,
	input: DeleteProjectBillToInput,
	onSuccess?: (response) => void,
	onError?: (error: Error) => void
): Disposable {
	trackEvent('Project Bill To Entity', 'Deleted', input);

	const cleanedInput = omit(input, ['projectId']) as Omit<DeleteProjectBillToInput, 'projectId'>;

	const variables = {
		input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedInput},
	};

	return commitMutation<DeleteProjectBillToMutation>(environment, {
		mutation,
		variables,
		configs: getConfigs(input),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
